import type { ToolTestResult } from '../../lib/api';
import styles from './ToolTestPanel.module.css';

export const ToolTestResultPanel = ({ result }: { result: ToolTestResult }) => {
  if ('status' in result) {
    if (result.status === 'success') {
      return (
        <div className={styles.resultPanel}>
          <span className={styles.successBadge}>success</span>
          <pre className={styles.resultBody}>{JSON.stringify(result.data, null, 2)}</pre>
        </div>
      );
    }
    return (
      <div className={styles.resultPanel}>
        <span className={styles.warningBadge}>upstream {result.httpStatus}</span>
        <pre className={styles.resultBody}>{JSON.stringify(result.body, null, 2)}</pre>
      </div>
    );
  }

  return (
    <div className={styles.resultPanel}>
      <span className={styles.errorBadge}>{result.error}</span>
      {result.message && <p className={styles.errorText}>{result.message}</p>}
      {result.fields && result.fields.length > 0 && (
        <ul className={styles.errorList}>
          {result.fields.map(field => (
            <li key={field}>{field}</li>
          ))}
        </ul>
      )}
    </div>
  );
};
